module.exports = ":host {\n  position: relative;\n  display: block; }\n\npopup-informativo-ava {\n  top: 30px;\n  right: 0px;\n  position: absolute;\n  z-index: 9; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao.component.scss
// module id = ./src/app/configuracao/configuracao-integracao/configuracao-integracao.component.scss
// module chunks = main